//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
// import PartnersConfiguration from '@/configurations/content/partners' // @/configurations/content/partners-dark для темной темы

export default {
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'TechMeetup #2 Java | JVM',
    description: [
      'Привет, коллега!',
      '<b>03 ноября</b> проведем наш очередной <b>TechMeetup по Java | JVM</b> в онлайн и офлайн формате.',
      'Мы собрали для тебя отличную программу докладов, посвященную разработке на Java и экосистеме JVM. Если ты являешься разработчиком или интересуешься этой областью, наш митап - идеальное мероприятие для тебя.',
      'Присоединяйся к нам! Тебя ждут крутые доклады, нетворкинг, призы, ламповое афтепати с едой и напитками! Ну прям, идеальная пятница!',
      '<img style="margin-right:30px" src="assets/logo/sp.png" width="35" height="35" align="left">Давно хочешь выступить или есть желание, но боишься - <a href="https://survey.inno.tech/techmeetup_t1_cfp">приходи к нам</a>, мы поможем тебе подготовиться и выступить на будущих мероприятиях!<br></img>',
      '<img style="margin-right:30px" src="assets/logo/fi.png" width="35" height="35" align="left">А еще - <a href="#my_position">посмотри наши вакансии</a>!</img>'

    ],
    date: '03 ноября 2023',
    time: '19:00'
  },
  activities: [
    {
      hash: 'sbvpFtKF',
      id: 1207
    //  tabName: 'Первый день'
    }
  //  {
  //    hash: 'PXBhAboi',
  //    id: 1106,
  //    tabName: 'Второй день' // название таба, при многозальном мероприятии
  //  }
  ],
  player: {
  // title: 'Дни конференции' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/map8.png'), // путь до изображения для блока с картинкой
    items: [
      'Митап пройдет по адресу: м. Красносельская/Бауманская, Спартаковский переулок 2с1, подъезд №7 (арт-пространство "Весна", 2 этаж).'
    //  'Не забудьте прихватить с собой паспорт, права или другой документ, удостоверяющий личность для прохода в бизнес-центр.'
    //  'Около офиса есть городская парковка (60₽ в час). Мест немного, но они есть.',
    //  '<a href="https://yandex.ru/maps/213/moscow/?indoorLevel=1&ll=37.661969%2C55.694389&mode=search&sll=37.661994%2C55.694457&text=55.694457%2C37.661994&z=17">Карта проезда</a>'
    ]
  },
 // partners: {
 //   //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
 //   items: PartnersConfiguration,
 //   title: 'Вакансии' // заголовок блока "Партнёры
// },

  info: {
    title: 'Вакансии', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<a href="https://t1.ru/career/"><img style="margin-right:30px" src="assets/partners/QR3.svg" width="130" height="130" align="left"></img></a>',
     'Если ты ищешь <a name="my_position"></a>карьеру, которая будет развивать твой потенциал, и хочешь работать с лучшими профессионалами в своей области, то  приглашаем тебя посетить наш карьерный сайт.',
     '<a href="http://bit.ly/t1career">Здесь ты найдешь</a> информацию о вакансиях, программе стажировок, а также о возможностях для профессионального и личностного роста в Холдинге Т1!'
    ]
  },

  footer: {
    copyright: 'Холдинг Т1 ©'
  }
}
